import React from 'react';
import clsx from 'clsx';
import { DownloadIcon } from '../../icons';
import styles from './MobileControls.module.css';

interface MobileControlsProps {
  showActionPanel: boolean;
  isDownloading: boolean;
  onInfoToggle: () => void;
  onDownload: (e?: React.MouseEvent) => void;
  onClose: () => void;
  onContentClick: (e: React.MouseEvent) => void;
  hideDownload?: boolean;
  primaryAction?: {
    label: string;
    onClick: () => void;
    icon?: React.ReactNode;
  };
}

export const MobileControls: React.FC<MobileControlsProps> = ({
  showActionPanel,
  isDownloading,
  onInfoToggle,
  onDownload,
  onClose,
  onContentClick,
  hideDownload,
  primaryAction,
}) => {
  const handlePrimary = (e: React.MouseEvent) => {
    e.stopPropagation();
    primaryAction?.onClick();
  };

  return (
    <div className={clsx(styles.mobileControls, showActionPanel && styles.controlsHidden)} onClick={onContentClick}>
      <div className={styles.mobileControlsLeft}>
        <button
          className={clsx(styles.mobileButton, showActionPanel && styles.active)}
          onClick={onInfoToggle}
        >
          <i className="fa-solid fa-circle-info" />
        </button>
        {primaryAction ? (
          <button
            className={clsx(styles.mobileButton, styles.primary, styles.extended)}
            onClick={handlePrimary}
          >
            {primaryAction.icon ?? <i className="fa-solid fa-arrow-right" />}
            <span className={styles.extendedLabel}>{primaryAction.label}</span>
          </button>
        ) : !hideDownload && (
          <button className={clsx(styles.mobileButton, styles.primary)} onClick={onDownload}>
            {isDownloading ? <i className="fa-solid fa-circle-notch fa-spin" /> : <DownloadIcon />}
          </button>
        )}
      </div>

      <button className={styles.mobileBackButton} onClick={onClose}>
        <i className="fa-solid fa-arrow-left" />
      </button>
    </div>
  );
};
